/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import "./styles/style.scss";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import routes from "./routes/routes";
import PrivateRoute from "./routes/privateRoutes";
import AdminApp from "./components/admin/AdminApp";
import { withTranslation } from "react-i18next";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { AmwayIDOktaConfig } from "./core/authentication";

/**
 * This component is the entry point of the application.
 */
function App(appProps: any) {
  const history = useHistory();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  // Okta (consumer site) client
  const authClient: any = new OktaAuth(AmwayIDOktaConfig());

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string) => {
    history.replace(
      toRelativeUrl(originalUri, window.location.origin) + "loginsuccessful"
    );
  };

  const customAuthHandler = () => {
    history.push("/loginsuccessful");
  };

  // Preserve existing scroll-to-top behavior
  history.listen((_location, _action) => {
    window.scrollTo(0, 0);
  });

  // Admin area (Entra/MSAL)
  if (isAdmin) {
    return (
      <Switch>
        <Route path="/admin" component={AdminApp} />
      </Switch>
    );
  }

  // Consumer area (Okta)
  return (
    <Security
      oktaAuth={authClient}
      restoreOriginalUri={restoreOriginalUri}
      onAuthRequired={customAuthHandler}
    >
      <Switch>
        {routes.map((route, index) => (
          <PrivateRoute {...route} {...appProps} key={route.path} />
        ))}
      </Switch>
    </Security>
  );
}

export default withTranslation("common")(App);